__turbopack_context__.v({
  "th": "table-module__uC4Zna__th",
  "thead": "table-module__uC4Zna__thead",
});
